import { useContext, useMemo } from 'react';
import CurrentUserEnquiryContextContext from 'providers/CurrentUserEnquiryContext/CurrentUserEnquiryContext.context';
import { Industry } from 'models/Industry';

export default function useEnquiryNameSugestion(industry: Industry) {
  const { userEnquiryContext } = useContext(CurrentUserEnquiryContextContext);

  return useMemo(() => {
    if (!industry) return '';

    const existingTags = new Set((userEnquiryContext ?? []).map(({ tag }) => tag));

    if (!existingTags.has(industry)) return industry;

    let n = 1;
    while (existingTags.has(`${industry} (${n})`)) n++;
    return `${industry} (${n})`;
  }, [industry, userEnquiryContext]);
}
